import { CMS_PERMISSIONS } from '../constants/permissions';

type PermissionChecker = (permission: string) => boolean;

export const DEFAULT_CMS_FALLBACK_ROUTE = '/categorias';

const CMS_FALLBACK_ROUTE_PERMISSIONS = [
  { route: DEFAULT_CMS_FALLBACK_ROUTE, permission: CMS_PERMISSIONS.categories.viewAny },
  { route: '/enclaves', permission: CMS_PERMISSIONS.enclaves.viewAny },
  { route: '/rutas', permission: CMS_PERMISSIONS.routes.viewAny },
  { route: '/noticias', permission: CMS_PERMISSIONS.news.viewAny },
  { route: '/analiticas', permission: CMS_PERMISSIONS.analytics.viewAny },
  { route: '/auditorias', permission: CMS_PERMISSIONS.audits.viewAny },
  { route: '/usuarios', permission: CMS_PERMISSIONS.users.viewAny },
] as const;

export function resolveFirstAccessibleCmsRoute(hasPermission: PermissionChecker): string | null {
  const match = CMS_FALLBACK_ROUTE_PERMISSIONS.find(({ permission }) => hasPermission(permission));

  return match?.route ?? null;
}
